import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';
import { take } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-delete-account',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAccountComponent {
  public userEmail: string | undefined;
  public isSendToEmail: boolean = false;

  constructor(private authService: AuthService, private cd: ChangeDetectorRef) {
    this.userEmail = this.authService.userEmail;
    this.cd.markForCheck();
  }

  public onClickDeleteAccount(): void {
    this.authService
      .accountRequestDeletion()
      .pipe(take(1))
      .subscribe((success: boolean) => {
        if (!success) {
          alert('Account deletion failed');
          window.location.href = this.authService.redirectUrl;
          return;
        }
        this.isSendToEmail = true;
        this.cd.markForCheck();
      });
  }
}
